import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
export const currenciesQuery = gql `
  query upsells_currenciesQuery {
    currencies {
      icon
      id
      multiplier
      name
      symbol
      zeroDecimal
    }
  }
`;
export const useCurrencies = (props) => {
    const useQuery = (props === null || props === void 0 ? void 0 : props.useQuery) || defaultUseQuery;
    const { client, data, error, loading } = useQuery(currenciesQuery);
    return {
        currencies: (data === null || data === void 0 ? void 0 : data.currencies) || [],
        error: error === null || error === void 0 ? void 0 : error.message,
        isLoading: loading,
        onSelectCurrency: (currency) => client.writeData({
            data: { selectedCurrency: currency },
        }),
    };
};

// @zapier/upsells@8.0.1 (466b4077f)
